import 'react-tabs/style/react-tabs.css';
import SearchImportRefresh from './SearchImportRefresh';
import React from 'react';
import refresh from '../../pics/icons/magPlus.PNG'
import OptionButton from '../EncounterColumn/OptionButton';

function getKey(c) {
    let keyExtra = ""
    if(c?.from === 'dnd_b')
        keyExtra = c.dnd_b_player_id
    else if(c?.dmb_homebrew_guid)
        keyExtra = c?.dmb_homebrew_guid
    else 
        keyExtra = c.sourceShort

    return c.name + keyExtra;
}

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
}

function highlightSubstring(substring, fullString) {
    if (!substring) return fullString;
    const parts = fullString.split(new RegExp(`(${escapeRegExp(substring)})`, 'gi')); // Split on the substring, keeping it in the result

    return (
        <span>
            {parts.map((part, index) =>
                part.toLowerCase() === substring.toLowerCase() ? (
                    <b key={index} style={{
                        textShadow: '1px 1px 2px gray',
                    }}>{part}</b> 
                ) : (
                    part 
                )
            )}
        </span>
    );
}

const ImportList = ({displayedItems, encounterGuid, searchTerm, handleSearchSelectCreature, xClicked, handleXClick, colors, shake}) => {    
    // Count creatures per unique campaign and group them
    const campaignGroups = {};
    displayedItems.forEach(creature => {
        const campaign = creature.campaign || "No Campaign";
        if (!campaignGroups[campaign]) campaignGroups[campaign] = [];
        campaignGroups[campaign].push(creature);
    });

    const handleAddAll = (campaign) => {
        campaignGroups[campaign].forEach(c => {
            handleSearchSelectCreature(c, "add")
        })
    }

    return (
        <>
            {Object.entries(campaignGroups).map(([campaign, creatures]) => (
                <ul className="campaignGroupWrapper" key={campaign} style={{padding: 0, margin: 0}}>
                    <li className="campaignGroupHeader" style={{ display: 'flex', fontWeight: 600, fontSize: 16, margin: "8px 0 0px 0", listStyle: "none", borderBottom: "2px solid #BBBBBB" }}>
                        {highlightSubstring(searchTerm, campaign)}
                        <OptionButton src={refresh} 
                            message={`Add all: ${campaign}`} 
                            onClickFunction={() => handleAddAll(campaign)} 
                            imgClassName={'addAllButton'} 
                        />
                    </li>
                    {creatures.map((creature, index) => (
                        <li
                            className={`listItem ${shake === creature.creatureGuid ? "alreadySelected" : ""}`}
                            key={getKey(creature)}
                            onClick={(e) => handleSearchSelectCreature(creature, "select", e)}
                            style={{listStyle: "none"}}
                        >
                            <div className={`searchListCreatureContainer ${(xClicked.click && index > xClicked.index) ? "animated-box" : ""}`}
                                style={creature?.alignment ? {borderLeft: `6px solid ${colors[creature?.alignment]}`} : {}}>
                                <div className="monsterEncounterIconContainer">
                                    <img className="monsterSearchIcon" src={creature.avatarUrl} alt={"list Icon"} />
                                </div>
                                <div className='searchListCreatureDetails'>
                                    <span>
                                        <strong>{highlightSubstring(searchTerm, creature.name)}</strong>  
                                    </span>
                                    <div className='searchCreatureSmallDetails'>
                                        <span className='monsterSearchDetailText'>{creature?.campaign && <b>{highlightSubstring(searchTerm, creature.campaign)} - </b>}</span>
                                        <span className='monsterSearchDetailText'>{highlightSubstring(searchTerm, creature.dnd_b_player_id)}</span>
                                    </div>
                                </div>
                                <div className='searchListButtonContainer'>
                                    <button className='searchCreatureX' onClick={(event) => {
                                        event.stopPropagation();
                                        handleXClick(creature, index) ;
                                    }}>
                                        ❌
                                    </button>
                                    <SearchImportRefresh creature={creature} encounterGuid={encounterGuid}/>
                                    <button className='monsterSearchAdd' style={{marginRight: '8px'}} onClick={(e) => handleSearchSelectCreature(creature, "add", e)}>
                                        ➕
                                    </button>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            ))}
        </>
    );
}

export default ImportList;